import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { Input } from "antd"
import React, { Dispatch, FC, useState, useTransition } from "react"

export const AppSearchInput: FC<{
  search: string
  handleSearch: Dispatch<string>
  className?: string
  placeholder?: string
}> = ({ search, handleSearch, className, placeholder = "Search" }) => {
  return (
    <Input
      placeholder={placeholder}
      prefix={<MagnifyingGlassIcon className="w-4 h-4 text-neutral-300" />}
      value={search}
      onChange={(e) => handleSearch(e.target.value)}
      className={className + " w-full lg:w-[280px]"}
      allowClear
      bordered
    />
  )
}
